import HistoryContext from "@insite/mobius/utilities/HistoryContext";
import linkTo from "@store/utilities/linkTo";
import { useContext } from "react";

const useLinksTo = (urls?: Array<string | undefined>) => {
    const { history } = useContext(HistoryContext);

    return urls?.map(url => () => linkTo(history, url)) ?? [];
};

export default useLinksTo;
